import { styled } from 'linaria/react';

export const FadeContainer = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: var(--layout-width);
  height: 78px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0.61%,
    rgba(255, 255, 255, 0.81) 37.33%,
    #fff 100%
  );
  pointer-events: none;
`;
export const AntifadeContainer = styled.div`
  @media (--to-tablet) {
    z-index: 1;
    height: var(--space-500);
    margin: 0 -16px;
    background: linear-gradient(180deg, rgba(70, 76, 92, 0.04) 0%, rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
  }
`;
